import { Component } from 'react';


class MobileInvitationDesign extends Component {
  componentDidMount () {
    evite.when('block js').then(() => {
      if (window.is_premium && window.NavigationView) {
        // TODO - prevent re-instantiation
        window.NavigationView.initPremiumInvitationNav();
      }
    });
  }

  shouldComponentUpdate() {
    return false;
  }

  componentWillMount() {
    const node = document.getElementById('design-template-wrapper');
    this.designMarkup = node.innerHTML;
  }

  render() {
    return (
      <div
        id="invitation_container"
        dangerouslySetInnerHTML={{__html: this.designMarkup}}
      />
    )
  }
}

export { MobileInvitationDesign };
export default MobileInvitationDesign;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/rsvp/components/mobile-invitation-design.es6